export default class AuthService {
  constructor(http) {
    this.http = http;
  }

  async login(userInfo) {
    return this.http.fetch("/api/auth/login", {
      method: "POST",
      body: JSON.stringify(userInfo),
    });
  }

  async me() {
    return this.http.fetch("/api/auth/me", {
      method: "GET",
    });
  }

  async logout() {
    return this.http.fetch("/api/auth/logout", {
      method: "POST",
    });
  }

  async csrfToken() {
    const resp = await this.http.fetch("/api/auth/csrf-token", {
      method: "GET",
    });
    return resp.csrfToken;
  }

  async byGoogleLogin(googleData) {
    return this.http.fetch("/api/auth/google-login", {
      method: "POST",
      body: JSON.stringify(googleData),
    });
  }

  /** 위애나 SSO: authorize 후 세션 쿠키가 있을 때 username/password 로 code 발급 URL 획득 */
  async weaenaSsoCode({ username, password }) {
    const data = await this.http.fetch("/api/auth/sso/weaena/code", {
      method: "POST",
      body: JSON.stringify({ username, password }),
      skipUnauthorizedEvent: true,
    });
    if (data?.success === true && typeof data.redirectUrl === "string") {
      return data.redirectUrl;
    }
    const err = new Error(
      data?.message || "위애나 SSO 로그인 처리에 실패했습니다."
    );
    err.errorCode = data?.error;
    err.status = 200;
    throw err;
  }
}
